import { css } from 'linaria';

export const akinatorWrap = css`
  display: block;
  width: 100%;
  min-width: 0;
  padding: var(--space-75) var(--space-200) !important;
  overflow-y: hidden;
  overflow-x: auto;
  height: fit-content;
  scrollbar-width: none;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const akinatorItemsWrap = css`
  display: flex;
  position: relative;
  width: max-content;
  min-width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: var(--space-100);

  & > * {
    flex: 0 0 auto;
  }
`;

export const akinatorCompletionsWrap = css`
  display: block;
  width: 100%;
  padding: var(--space-75) var(--space-200);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (--from-desktop) {
    overflow: hidden;
  }
`;

export const akinatorCompletionsItems = css`
  display: flex;
  width: max-content;
  min-width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: var(--space-100);
`;

export const akinatorButton = css`
  flex: 0 0 auto;
  max-width: 190px;

  @media (--only-desktop) {
    max-width: 160px;
  }

  &.active {
    --button-bg: var(--background-secondary);
    --button-hover-bg: var(--background-secondary);
  }
`;

export const akinatorButtonText = css`
  display: inline !important;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const akinatorCompletionButton = css`
  flex: 0 0 auto;

  &.active {
    --button-bg: var(--background-secondary);
    --button-hover-bg: var(--background-secondary);
    --button-border-color: var(--background-secondary);
  }
`;

export const akinatorCompletionButtonText = css`
  white-space: nowrap;
`;
